module.exports = __webpack_public_path__ + "static/LogoHostDime-0531d6455ff49311228b08e8be93528f.pdf";